import React, {
    useCallback, useEffect, useState,
} from 'react';
import {
    get, set, isUndefined, isEmpty
} from 'lodash';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from 'e1p-portals-wizard-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import metadata from '../EUVehicleOperatorPage.metadata.json5';

function ViewEUVehicleOperatorPage(props) {
    const {
        wizardData: submissionVM, updateWizardData, isSkipping
    } = props;
    const [checkScrolling, setCheckScrolling] = useState(false);
    const [indexStale, setIndexStale] = useState(false);
    const {
        onValidate, initialValidation,
        registerComponentValidation
    } = useValidation('EUVehicleOperatorPage');

    useEffect(() => {
        if (isUndefined(submissionVM.lobData.personalUmbrella_EU.vehicleOperators.value)) {
            set(submissionVM.lobData.personalUmbrella_EU.vehicleOperators, 'value', []);
        }

        updateWizardData(submissionVM);
        registerComponentValidation(() => submissionVM.lobData.personalUmbrella_EU.vehicleOperators.aspects.subtreeValid);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // this grabs the latest element on the page --
    // this is to make sure this element has been loaded
    const latestVehicleOperatorElement = document.getElementById(
        `euVehicleOperatorComponentDiv${submissionVM.lobData.personalUmbrella_EU.vehicleOperators.children.length - 1}`
    );

    useEffect(() => {
        // indexStale set in the add vehicle operator function
        // once latest element is loaded and a new vehicle operator is added
        // we check if the button should be visible
        if (latestVehicleOperatorElement && indexStale) {
            setCheckScrolling(true);
            setIndexStale(false);
        }
    }, [indexStale, latestVehicleOperatorElement]);

    /**
     * E1PAP1PC-15717: E1P QA Design UX Adherence, as per the story
     * we need to focus on first element of the new node.
     * so that the Tab order should work as expected.
     */
    useEffect(() => {
        const vehicleOperatorElement = document.getElementById(`firstName${submissionVM.lobData.personalUmbrella_EU.vehicleOperators.length - 1}`);

        if (vehicleOperatorElement
            && isEmpty(vehicleOperatorElement.value)
            && vehicleOperatorElement.focus !== undefined) {
            vehicleOperatorElement.focus();
        }
    }, [submissionVM.lobData.personalUmbrella_EU.vehicleOperators.length]);

    /**
     * Define Jutro component properties to be overridden and given dynamic behavior.
     */
    const overrideProps = {
        '@field': {
            showRequired: true,
            readOnly: true
        },
        vehicleOperatorPageLoadingIndicator: {
            loaded: !isSkipping
        },
        vehicleOperatorPageContainer: {
            visible: !isSkipping
        },
        scrollingComponentId: {
            checkScrolling,
            setCheckScrolling,
            scrollableDiv: document.getElementById('vehicleOperatorsContainer')
        },
        EUVehicleOperatorGrid: {
            key: get(submissionVM, 'lobData.personalUmbrella_EU.vehicleOperators', []).length,
            transactionVM: submissionVM,
            drivers: get(submissionVM, 'lobData.personalUmbrella_EU.vehicleOperators', []),
            path: 'lobData.personalUmbrella_EU.vehicleOperators.children',
            onValidate,
            showErrors: false,
            setCheckScrolling,
            updateWizardData,
            viewOnlyMode: true
        },
        addVehicleOperator: {
            visible: false
        }
    };

    /**
     * Helper callback for writing values to the view model.
     */
    const writeValue = useCallback(
        (newVal, path) => {
            set(submissionVM, `${path}.value`, newVal);
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );

    /**
     * Define resolvers to be used when resolving values for this Jutro component.
     */
    const resolvers = {
        resolveCallbackMap: {
            addVehicleOperator: undefined,
            onRemoveVehicleOperator: undefined,
            onValidate
        }
    };

    // if validation errors are thrown we cant jump to cov page

    /**
     * Helper callback for handling navigation to the next wizard screen.
     */
    const onNext = useCallback(
        async () => submissionVM,
        [submissionVM]
    );

    /**
     * Define rendering behaviors for this Jutro component.
     */
    return (
        <WizardPage
            onNext={onNext}
            skipWhen={initialValidation}
            shouldLink
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
                callbackMap={resolvers.resolveCallbackMap}
                onValueChange={writeValue}
            />
        </WizardPage>
    );
}

ViewEUVehicleOperatorPage.propTypes = wizardProps;
export default ViewEUVehicleOperatorPage;
